import gql from 'graphql-tag'
export default gql`
query FrameRates {
  FrameRates {
        id
        frameRate
      }
    }
  `
